<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
	<!-- <label for="" class="title-history">
		<i class="fa fa-shoe-prints"></i>Pasos
	</label> -->
	<input type="radio" [(ngModel)]="step" value="0" checked id="tab1">
	<label for="tab1">
		<i class="fa fa-building"></i>General
		<i *ngIf="getDisabledGeneral()" placement="right" tooltip="Completa los campos de este apartado"
			class="fa fa-asterisk text-danger"></i>
	</label>

	<input type="radio" [(ngModel)]="step" value="1" id="tab2">
	<label for="tab2">
		<i class="fa fa-phone"></i>Social
		<i *ngIf="newCompany.phones.length == 0" [placement]="'right'"
			[tooltip]="newCompany.phones.length == 0?'Ingresa por lo menos un teléfono':''"
			class="fa fa-asterisk text-danger"></i>
	</label>

	<input type="radio" [(ngModel)]="step" value="2" id="tab3">
	<label for="tab3">
		<i class="fa fa-calendar"></i>Horarios
	</label>

	<input type="radio" [(ngModel)]="step" value="4" id="tab5">
	<label for="tab5">
		<i class="fa fa-thumbs-up"></i>Actividades <i *ngIf="newCompany.activities.length == 0"
			[placement]="'right'"
			[tooltip]="newCompany.activities.length == 0?'Ingresa por lo menos una actividad':''"
			class="fa fa-asterisk text-danger"></i>
	</label>

	<input type="radio" [(ngModel)]="step" value="5" id="tab6">
	<label for="tab6">
		<i class="fa fa-user-tie"></i>Representante
	</label>

	<input type="radio" [(ngModel)]="step" value="6" id="tab7">
	<label for="tab7">
		<i class="fa fa-id-badge"></i>Contactos
		<i *ngIf="newCompany.contacts.length == 0" [placement]="'left'"
			[tooltip]="newCompany.contacts.length == 0?'Ingresa por lo menos un contacto':''"
			class="fa fa-asterisk text-danger"></i>
	</label>
</div>
<div class="body-tab">
	<div [hidden]="step!='0'" id="tab1-container">
		<h1>DATOS GENERALES DE LA EMPRESA <i *ngIf="getDisabledGeneral()" placement="right"
				tooltip="Completa los campos de este apartado" class="fa fa-asterisk text-danger"></i>
		</h1>
		<div class="row">
			<div class="col-sm-10">
				<div class="row">
					<div class="col-sm-8 form-group">
						<label for="name" class="form-label">Nombre <ng-container
								*ngTemplateOutlet="require"></ng-container></label>
						<input type="text" id="name" [(ngModel)]="newCompany.name"
							placeholder="Nombre de la empresa" name="name" class="form-control">
					</div>
					<div class="col-sm-4 form-group d-flex align-items-center" style="font-size: 1.2rem;">
						<label class="form-label mb-0">
							<input type="checkbox"
								style="transform: scale(1.5); margin-right: 10px;"
								[(ngModel)]="newCompany.administrative"
								(change)="onAdministrativeToggle()" />
							<strong>Administrativa</strong>
						</label>
					</div>
					<div class="col-sm-4 form-group" *ngIf="!newCompany.administrative">
						<label for="nit" class="form-label">NIT <ng-container *ngTemplateOutlet="require"></ng-container></label>
						<input type="text" id="nit" (change)="checkNIT()" [(ngModel)]="newCompany.nit"
							placeholder="NIT de la empresa" name="nit" class="form-control">
						<p *ngIf="messageNIT" class="form-text text-danger">{{messageNIT}}</p>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-8 form-group">
						<label for="address" class="form-label">Dirección <ng-container
								*ngTemplateOutlet="require"></ng-container></label>
						<input type="text" id="address" [(ngModel)]="newCompany.address"
							placeholder="Dirección de la empresa" name="name" class="form-control">
					</div>
					<div class="col-sm-4 form-group">
						<label for="email" class="form-label">Correo Electronico <ng-container
								*ngTemplateOutlet="require"></ng-container></label>
						<input type="text" id="email" [(ngModel)]="newCompany.mail"
							placeholder="ej. empresa@dominioempresa.com" name="email" class="form-control">
					</div>
				</div>
				<div class="row">
					<div class="col form-group">
						<label for="country" class="form-label">Pais <ng-container
								*ngTemplateOutlet="require"></ng-container></label>
						<select name="country" [(ngModel)]="country" (change)="getDepartments()" id="country"
							class="form-select">
							<option value="undefined">Seleccione un pais</option>
							<option *ngFor="let country of countries" value="{{country.id}}">{{country.name}}
							</option>
						</select>
					</div>
					<div class="col form-group">
						<label for="departament" class="form-label">Departamento <ng-container
								*ngTemplateOutlet="require"></ng-container></label>
						<select [disabled]="!country && departments.length == 0" [(ngModel)]="department"
							name="departament" id="departament" (change)="getTowns()" class="form-select">
							<option value="undefined">Seleccione un departamento</option>
							<option *ngFor="let department of departments" value="{{department.id}}">
								{{department.name}}</option>
						</select>
					</div>
					<div class="col form-group">
						<label for="town" class="form-label">Municipio <ng-container
								*ngTemplateOutlet="require"></ng-container></label>
						<select name="town" [disabled]="!department" id="town" [(ngModel)]="newCompany.town"
							class="form-select">
							<option value="undefined">Seleccione un municipio</option>
							<option *ngFor="let town of towns" value="{{town.id}}">{{town.name}}</option>
						</select>
					</div>
				</div>
			</div>
			<div class="col-sm-2 img-container">
				<div class="parent" (click)="uploadLogo()">
					<img src="{{newCompany.logo?newCompany.logo:'/assets/img/nophoto.svg'}}" alt="" srcset="">
					<i class="fa fa-upload"></i>
				</div>
				<input type="file" (change)="changedFile($event)" name="img" id="img" style="display:none">
			</div>
		</div>
	</div>
	<div [hidden]="step!='1'">
		<h1>Telefonos <i *ngIf="newCompany.phones.length == 0" [placement]="'right'"
				[tooltip]="newCompany.phones.length == 0?'Ingresa por lo menos un teléfono':''"
				class="fa fa-asterisk text-danger"></i></h1>
		<div class="row">
			<div class="col form-group">
				<label for="areaCode" class="form-label">Código de area</label>
				<input type="number" [(ngModel)]="newPhone.area" id="areaCode" placeholder="Código de area"
					name="areaCode" class="form-control">
			</div>
			<div class="col form-group">
				<label for="phone" class="form-label">Télefono</label>
				<input type="number" [(ngModel)]="newPhone.phone" id="phone"
					placeholder="Ingresa número de telefono" name="phone" class="form-control">
			</div>
			<div class="col form-group">
				<label for="extension" class="form-label">Extensión</label>
				<input type="number" [(ngModel)]="newPhone.extension" id="extension"
					placeholder="Ingresa la extensión" name="extension" class="form-control">
			</div>
			<div class="col center-button">
				<button class="btn btn-success" (click)="addPhone()"
					[disabled]="!newPhone.area || !newPhone.extension || !newPhone.phone">
					<i class="fa fa-circle-plus"></i>AGREGAR
				</button>
			</div>
		</div>
		<div class="collection-phone mt-3">
			<p *ngFor="let phone of newCompany.phones; let i = index" class="phone-tag">
				<i class="fa fa-phone"></i> +{{phone.area}} {{phone.phone}} <span
					style="opacity:0.5; color:gray;">+Ext</span> ({{phone.extension}}) <i
					class="clickeable fa fa-trash text-danger" (click)="newCompany.phones.splice(i,1)"></i>
			</p>
		</div>
		<h1>Redes sociales</h1>
		<div class="row">
			<div class="col form-group">
				<label for="site" class="form-label">Sitio</label>
				<input type="text" [(ngModel)]="newCompany.page" id="site" placeholder="ej. www.empresa.com"
					name="site" class="form-control">
			</div>
			<div class="col form-group">
				<label for="facebook" class="form-label">Facebook</label>
				<input type="text" [(ngModel)]="newCompany.facebook" id="facebook" name="facebook"
					placeholder="ej. www.facebook.com" class="form-control">
			</div>
			<div class="col form-group">
				<label for="twitter" class="form-label">Twitter</label>
				<input type="text" [(ngModel)]="newCompany.twitter" id="twitter" name="twitter"
					placeholder="ej. www.twitter.com" class="form-control">
			</div>
		</div>
	</div>
	<div [hidden]="step!='2'">
		<div class="row">
			<div class="col form-group">
				<label for="opening" class="form-label">Hora de apertura:</label>
				<input type="time" name="opening" [(ngModel)]="opening" id="opening" class="form-control">
			</div>
			<div class="col form-group">
				<label for="closing" class="form-label">Hora de cierre:</label>
				<input type="time" name="closing" [(ngModel)]="closing" id="closing" class="form-control">
			</div>
			<div class="col align-middle" style="display:flex; align-items:center;">
				<div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
					<div class="btn-group" role="group" aria-label="Basic checkbox toggle button group">
						<input [(ngModel)]="days[0]" type="checkbox" class="btn-check" id="monday"
							autocomplete="off">
						<label tooltip="Lunes" class="btn btn-outline-primary" for="monday">LU</label>

						<input [(ngModel)]="days[1]" type="checkbox" class="btn-check" id="tuesday"
							autocomplete="off">
						<label tooltip="Martes" class="btn btn-outline-primary" for="tuesday">MA</label>

						<input [(ngModel)]="days[2]" type="checkbox" class="btn-check" id="wednesday"
							autocomplete="off">
						<label tooltip="Miercoles" class="btn btn-outline-primary" for="wednesday">MI</label>

						<input [(ngModel)]="days[3]" type="checkbox" class="btn-check" id="thursday"
							autocomplete="off">
						<label tooltip="Jueves" class="btn btn-outline-primary" for="thursday">JU</label>

						<input [(ngModel)]="days[4]" type="checkbox" class="btn-check" id="friday"
							autocomplete="off">
						<label tooltip="Viernes" class="btn btn-outline-primary" for="friday">VI</label>

						<input [(ngModel)]="days[5]" type="checkbox" class="btn-check" id="saturday"
							autocomplete="off">
						<label tooltip="Sábado" class="btn btn-outline-primary" for="saturday">SA</label>

						<input [(ngModel)]="days[6]" type="checkbox" class="btn-check" id="sunday"
							autocomplete="off">
						<label tooltip="Domingo" class="btn btn-outline-primary" for="sunday">DO</label>
						<button (click)="pushSchedules()"
							[disabled]="!opening || !closing || getDisabledForSum()" tooltip="Agregar"
							type="button" class="btn btn-info"><i class="fa fa-circle-plus"></i></button>
					</div>
				</div>
			</div>
		</div>
		<div class="table-responsive mt-3">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle">
						<th>
							HORA
							<i (click)="clean(-1)" tooltip="Limpiar todo" tooltipPlacement="bottom"
								class="fa fa-broom clickeable text-info"></i>
						</th>
						<th>
							<span (click)="clean(0)" [class.clean]="schedules[0].opening">
								LUNES <i class="fa fa-broom broom text-info clickeable"></i>
							</span>
						</th>
						<th>
							<span (click)="clean(1)" [class.clean]="schedules[1].opening">
								MARTES <i class="fa fa-broom broom text-info clickeable"></i>
							</span>
						</th>
						<th>
							<span (click)="clean(2)" [class.clean]="schedules[2].opening">
								MIERCOLES <i class="fa fa-broom broom text-info clickeable"></i>
							</span>
						</th>
						<th>
							<span (click)="clean(3)" [class.clean]="schedules[3].opening">
								JUEVES <i class="fa fa-broom broom text-info clickeable"></i>
							</span>
						</th>
						<th>
							<span (click)="clean(4)" [class.clean]="schedules[4].opening">
								VIERNES <i class="fa fa-broom broom text-info clickeable"></i>
							</span>
						</th>
						<th>
							<span (click)="clean(5)" [class.clean]="schedules[5].opening">
								SABADO <i class="fa fa-broom broom text-info clickeable"></i>
							</span>
						</th>
						<th>
							<span (click)="clean(6)" [class.clean]="schedules[6].opening">
								DOMINGO <i class="fa fa-broom broom text-info clickeable"></i>
							</span>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle">
						<td>APERTURA</td>
						<ng-container *ngFor="let day of schedules">
							<td [rowSpan]="day.opening?1:2">
								<span *ngIf="day.opening">{{day.opening}}</span>
								<span class="text-muted" *ngIf="!day.opening"><i
										class="fa fa-circle-info"></i>{{'Sin horario ingresado'}}</span>
							</td>
						</ng-container>
					</tr>
					<tr class="tr-middle">
						<td>CIERRE</td>
						<ng-container *ngFor="let day of schedules">
							<td *ngIf="day.closing">
								{{day.closing}}
							</td>
						</ng-container>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div [hidden]="step!='4'">
		<h1>Actividades
			<i *ngIf="newCompany.activities.length == 0" [placement]="'right'"
				[tooltip]="newCompany.activities.length == 0?'Ingresa por lo menos una actividad':''"
				class="fa fa-asterisk text-danger"></i>
		</h1>
		<div class="form-group">
			<label for="activity" class="form-label">Selecciona actividades</label>
			<div class="input-group">
				<app-input-autocomplete [filterElements]="input.filterElements" [allBorderRadius]="true"
					[inputs]="input" (inputMethod)="write()" (changeStatus)="select($event.filterElement)"
					(getTitle)="$event.filterElement.title = $event.filterElement.code + ' - ' +  $event.filterElement.name"
					[placeholder]="'Ingresa el código o el nombre de la actividad, luego selecciona'">
				</app-input-autocomplete>
			</div>
		</div>
		<ul class="mt-3">
			<li *ngFor="let activity of newCompany.activities; let i = index">
				{{collectionActivities[activity].code + " " + collectionActivities[activity].name}}
				<i class="clickeable fa fa-trash text-danger" (click)="newCompany.activities.splice(i,1)"></i>
			</li>
		</ul>
	</div>
	<div [hidden]="step!='5'">
		<div class="row">
			<div class="col representative">
				<h1>Datos Representante</h1>
				<div class="form-group">
					<label for="representative" class="form-label">Nombre Representante</label>
					<input type="text" name="representative" id="representative"
						[(ngModel)]="newCompany.representative" class="form-control"
						placeholder="Ingresa el nombre del representante">
				</div>
				<div class="form-group">
					<label for="representativeMail" class="form-label">Correo Representante</label>
					<input type="text" name="representativeMail" id="representativeMail"
						[(ngModel)]="newCompany.representativeMail" class="form-control"
						placeholder="Ingresa el correo del representante">
				</div>
			</div>
			<div class="col img-container">
				<div class="parent" (click)="uploadDPI()">
					<img src="{{dpi?dpi:'/assets/img/nophoto.svg'}}" alt="" srcset="">
					<i class="fa fa-upload"></i>
				</div>
				<input type="file" (change)="changedFile($event, false)" name="dpi" id="dpi"
					style="display:none">
			</div>
		</div>
	</div>
	<div [hidden]="step!='6'">
		<h1>Contactos
			<i *ngIf="newCompany.contacts.length == 0" [placement]="'left'"
				[tooltip]="newCompany.contacts.length == 0?'Ingresa por lo menos un contacto':''"
				class="fa fa-asterisk text-danger"></i>
			</h1>
		<div class="row">
			<div class="col form-group">
				<label for="nameContact" class="form-label">Nombre</label>
				<input type="text" [(ngModel)]="newContact.name" id="nameContact"
					placeholder="Nombre de contacto" name="nameContact" class="form-control">
			</div>
			<div class="col form-group">
				<label for="phoneContact" class="form-label">Teléfono</label>
				<input type="number" [(ngModel)]="newContact.phone" id="phoneContact" name="phoneContact"
					placeholder="Número de teléfono de contacto" class="form-control">
			</div>
			<div class="col form-group">
				<label for="emailContact" class="form-label">Email</label>
				<input type="text" [(ngModel)]="newContact.mail" id="emailContact" name="emailContact"
					placeholder="ej. contacto@empresadominio.com" class="form-control">
			</div>
			<div class="col center-button">
				<button class="btn btn-success"
					[disabled]="!newContact.name || !newContact.phone || !newContact.mail"
					(click)="pushContact()">
					<i class="fa fa-circle-plus"></i>AGREGAR
				</button>
			</div>
		</div>
		<div class="table-responsive mt-3" *ngIf="newCompany.contacts.length > 0">
			<table class="table table-bordered">
				<thead>
					<tr class="tr-middle">
						<th>Nombre</th>
						<th>Teléfono</th>
						<th>Email</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr class="tr-middle" *ngFor="let contact of newCompany.contacts; let i = index">
						<td>{{contact.name}}</td>
						<td>{{contact.phone}}</td>
						<td>{{contact.mail}}</td>
						<td>
							<i class="fa fa-trash clickeable text-danger"
								(click)="newCompany.contacts.splice(i,1)"></i>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
<ng-template #require>
	<span [tooltip]="'Campo requerido'" class="fa fa-asterisk text-danger"></span>
</ng-template>